import { Injectable } from '@angular/core'
import { Observable, Subject } from 'rxjs'

export interface BalanceChangedEvent {
  appointmentEstimateLinkChanged?: boolean
}

/**
 * App-wide "a patient's estimate balances changed" signal (PIA-2574).
 *
 * The estimate flow (finalize / recalculate / revert) mutates balances inside the
 * estimator, while the patient balance panels (profile sidebar card, balances list)
 * live in a separate part of the tree and fetch once. Without a shared signal those
 * panels stay stale until a page refresh. providedIn 'root' so the emitter and every
 * consumer share one Subject.
 */
@Injectable({ providedIn: 'root' })
export class BalanceEventsService {
  private readonly changedSubject = new Subject<BalanceChangedEvent>()
  readonly balancesChanged$: Observable<BalanceChangedEvent> = this.changedSubject.asObservable()

  notifyBalancesChanged(event: BalanceChangedEvent = {}): void {
    this.changedSubject.next(event)
  }
}
